/**
 * What the course assistant is called.
 *
 * One constant rather than a string in each component, because the name was
 * previously written out in eight places across three components and the
 * two system prompts, and renaming it meant finding all of them.
 *
 * The API has its own copy — a browser constant cannot reach the prompt the
 * model is given, and the model has to introduce itself by the same name the
 * panel shows. `apps/api/src/modules/ai/answering/assistant.ts` is the other
 * half; change both.
 */
export const ASSISTANT_NAME = 'Vagdevi';

/** For a title or an aria-label where the product needs naming too. */
export const ASSISTANT_FULL_NAME = `${ASSISTANT_NAME} — SkillXzen AI`;
